<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/spain/ribera-del-duero')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/spain/ribera-del-duero/pingus')">Pingus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/spain/ribera-del-duero/vega-sicilia')">Vega Sicilia
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/spain/ribera-del-duero')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Pingo</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        I vini pregiati spagnoli investibili sono spesso tristemente trascurati nel gioco del buon vino. Pingus, tuttavia, è l'eccezione alla regola. Come un buon xxx o un classico xxxx, questo è un produttore che merita il suo status internazionale. Non lasciarti ingannare dal suo nome stravagante, Pingus è serio quanto il buon vino spagnolo.
                    </div>

                    <div class="howto-title2">Cosa c'è in un nome?</div>
                    <div class="howto-text">
                        Prende il nome dal soprannome d'infanzia del proprietario della tenuta Peter Sisseck, Dominio de Pingus è stato fondato nel
                        Ribera del Duero nel 1995 da Sisseck, un uomo che bevve il suo primo sorso di vino a otto anni (un 1961
                        Château d&#39;Issan, nientemeno!). Sisseck si era trasferito in Spagna dalla sua nativa Danimarca nel 1990 a
                        gestire un piccolo appezzamento di terreno appartenente alla tenuta di sherry Ribera Del Duero. Cinque anni dopo,
                        si è imbattuto “per fortuna” in un vecchio vigneto nella subregione di La Horra. Non solo il
                        il terreno argilloso/calcareo offre un ottimo drenaggio ma c'erano resti di viti piantate nel 1929.
                        Sisseck acquistò immediatamente la tenuta e nello stesso anno rilasciò 325 casse di ultrapotenti
                        Tempranillo. “Sapevo entro 25 secondi dalla degustazione alla cieca che avremmo importato il vino, nonostante
                        il suo strano nome", dice l'amministratore delegato dell'emporio di vino britannico Corney and Barrow, Adam
                        Brett-Smith. Brett-Smith ha organizzato una degustazione con l'enormemente influente Robert Parker (this
                        essendo gli anni '90 era il momento di brillare di Parker) che gli diede il punteggio più alto possibile. È stata venduta
                        all'ingresso nel mercato a 15€; i prezzi nel 2019 ora superano abbondantemente i 1.200 euro a bottiglia.
                    </div>

                    <div class="howto-title2">Un colosso di una bottiglia</div>
                    <div class="howto-text">
                        Come molte grandi cose, Pingus divide le opinioni. Ci sono quelli che semplicemente adorano il denso
                        gusto fruttato, mentre altri non lo toccheranno. Che ti piaccia o no, Pingus ha un prezzo.
                        Nel secondo trimestre del 2019, una bottiglia media di Pingus è stata di € 800, con annate come il 2004 o il 2014
                        estendendosi bene a migliaia. Ma se stai davvero cercando un trofeo, allora il 1995 lo è
                        il Santo Graal dell'investitore di vini pregiati. Quasi il 20% dell'annata è ormai in fondo alla classifica
                        Atlantic quando affondò la portacontainer che esportava 75 casse in America (500 casse di
                        Persi anche i Premier Cru Chateaux Lafitte). Con una produzione di appena 500 casse all'anno, noi
                        ti permetterà di fare i conti per capire quanto sia diventata desiderabile quella particolare annata. Se
                        stai cercando un vino più tascabile, buono da bere quanto da conservare, ti suggeriamo
                        navigando verso il secondo vino di Pingu, Flor de Pingus.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Pingus</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Spanische erlesene Weine, die investitionswürdig sind, werden in der Welt der guten Weine leider oft übersehen. Pingus ist jedoch die Ausnahme von der Regel. Wie ein guter XXX oder ein klassischer XXX ist dies ein Produzent, der seinen internationalen Status verdient. Lassen Sie sich nicht von seinem skurrilen Namen täuschen, Pingus ist so seriös, wie guter spanischer Wein nur sein kann.
                    </div>

                    <div class="howto-title2">Was steckt in einem Namen?</div>
                    <div class="howto-text">
                        Dominio de Pingus wurde nach dem Spitznamen des Gutsbesitzers Peter Sisseck aus seiner Kindheit benannt
                        Ribera del Duero im Jahr 1995 von Sisseck, einem Mann, der im Alter von acht Jahren seinen ersten Schluck Wein trank (ein 1961).
                        Château d&#39;Issan, nicht weniger!). Sisseck war 1990 von seiner Heimat Dänemark nach Spanien gezogen
                        Wir verwalten ein kleines Grundstück, das zum Sherry-Anwesen Ribera Del Duero gehört. Fünf Jahre später,
                        „durch Zufall“ stieß er zufällig auf einen alten Weinberg in der Unterregion La Horra. Nicht nur das
                        Lehm-/Kalksteinböden bieten eine hervorragende Entwässerung, es gab jedoch Reste von Weinreben, die 1929 gepflanzt wurden.
                        Sisseck kaufte das Anwesen sofort und brachte im selben Jahr 325 Kisten Ultrakraft auf den Markt
                        Tempranillo. „Ich wusste innerhalb von 25 Sekunden nach der Blindverkostung, dass wir den Wein trotzdem importieren würden
                        „Es ist ein seltsamer Name“, sagt Adam, Geschäftsführer des britischen Weinhandels Corney and Barrow
                        Brett-Smith. Brett-Smith arrangierte eine Verkostung mit dem äußerst einflussreichen Robert Parker (dies
                        (in den 1990er Jahren war Parkers Zeit zu glänzen), der ihm die höchstmögliche Punktzahl verlieh. Es wurde verkauft
                        bei Markteintritt 15 €; Die Preise im Jahr 2019 liegen mittlerweile deutlich über 1.200 € pro Flasche.
                    </div>

                    <div class="howto-title2">Ein Riese von einer Flasche</div>
                    <div class="howto-text">
                        Wie bei vielen großartigen Dingen spaltet auch Pingus die Meinungen. Es gibt diejenigen, die das Dichte einfach lieben
                        fruchtiger Geschmack, während andere ihn nicht anrühren. Ob es Ihnen gefällt oder nicht, Pingus hat seinen Preis.
                        Im zweiten Quartal 2019 kostete eine Flasche Pingus durchschnittlich 800 Euro, bei Jahrgängen wie 2004 oder 2014
                        bis weit in die Tausende reichend. Aber wenn Sie wirklich auf der Suche nach einer Trophäe sind, dann ist 1995 genau das Richtige
                        Der heilige Gral des Weininvestors. Fast 20 % des Jahrgangs befinden sich mittlerweile im unteren Bereich
                        Atlantik, als das Containerschiff, das 75 Kisten nach Amerika exportierte, sank (500 Kisten davon).
                        Auch Premier Cru Chateaux Lafitte gingen verloren. Mit einer Produktion von nur 500 Kartons pro Jahr sind wir
                        Damit können Sie ausrechnen, wie begehrenswert dieser bestimmte Jahrgang geworden ist. Wenn
                        Wenn Sie auf der Suche nach einem handlicheren Wein sind, der sowohl gut zum Trinken als auch zum Aufbewahren geeignet ist, empfehlen wir Ihnen
                        auf dem Weg zu Pingus Zweitwein, Flor de Pingus.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Pingus</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Les vins fins espagnols pouvant être investis sont souvent malheureusement négligés dans le jeu des vins fins. Pingus, cependant, fait exception à la règle. Comme un bon xxx ou un xxxx classique, c'est un producteur qui mérite son statut international. Ne vous laissez pas berner par son nom original, Pingus est aussi sérieux que le bon vin espagnol.
                    </div>

                    <div class="howto-title2">Qu'y a-t-il dans un nom?</div>
                    <div class="howto-text">
                        Nommé d'après le surnom d'enfance du propriétaire du domaine Peter Sisseck, Dominio de Pingus a été fondé en
                        Ribera del Duero en 1995 par Sisseck, un homme qui a bu sa première gorgée de vin à l'âge de huit ans (un 1961
                        Château d'Issan, pas moins !). Sisseck avait déménagé en Espagne depuis son Danemark natal en 1990 pour
                        gérer une petite parcelle de terrain appartenant au domaine de sherry Ribera Del Duero. Cinq ans plus tard,
                        il est tombé par hasard sur un vieux vignoble dans la sous-région de La Horra. Non seulement le
                        le sol argilo-calcaire offre un excellent drainage mais il y avait des restes de vignes plantées en 1929.
                        Sisseck rachète immédiatement le domaine et sort la même année 325 caisses ultra puissantes
                        Tempranillo. « J'ai su dans les 25 secondes suivant la dégustation à l'aveugle que nous importerions le vin, malgré
                        son nom bizarre", déclare le directeur général de Corney and Barrow, emporium du vin britannique, Adam
                        Brett-Smith. Brett-Smith a organisé une dégustation avec le très influent Robert Parker (ce
                        étant les années 1990, il était temps pour Parker de briller) qui lui a donné son score le plus élevé possible. Il a été vendu
                        à l'entrée sur le marché à 15 € ; les prix en 2019 dépassent désormais largement les 1 200 € la bouteille.
                    </div>

                    <div class="howto-title2">Un monstre de bouteille</div>
                    <div class="howto-text">
                        Comme beaucoup de grandes choses, Pingus divise les opinions. Il y a ceux qui adorent simplement le dense
                        goût fruité, tandis que d'autres n'y toucheront pas. Que cela vous plaise ou non, Pingus a un prix.
                        Au deuxième trimestre 2019, une bouteille moyenne de Pingus était de 800 €, avec des millésimes comme le 2004 ou le 2014
                        s'étendant bien dans les milliers. Mais si vous cherchez vraiment un trophée, alors 1995 est
                        le Saint Graal de l'investisseur en vins fins. Près de 20% du millésime se situe désormais dans le bas du
                        Atlantic lorsque le porte-conteneurs qui exportait 75 caisses vers l'Amérique a coulé (500 caisses de
                        Les Châteaux Lafitte Premier Cru ont également été perdus). Avec une production de seulement 500 caisses par an, nous
                        vous permettra de faire le calcul pour déterminer à quel point ce millésime particulier est devenu convoité. Si
                        vous cherchez un vin de poche, aussi bon à boire qu'à garder, nous vous suggérons
                        naviguant vers le second vin de Pingu, Flor de Pingus.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Pingus</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Spanish investable fine wines are often sadly overlooked in the fine wine game. Pingus, however, is the exception to the rule. Like a good xxx or a classic xxxx, this is one producer that deserves its international status. Do not be fooled by its quirky name, Pingus is as serious as Spanish fine wine gets.
                    </div>

                    <div class="howto-title2">What’s in a name?</div>
                    <div class="howto-text">
                        Named after estate owner Peter Sisseck’s childhood nickname, Dominio de Pingus was founded in
                        Ribera del Duero in 1995 by Sisseck, a man who had his first sip of wine aged eight (a 1961
                        Château d&#39;Issan, no less!). Sisseck had moved to Spain from his native Denmark in 1990 to
                        manage a small parcel of land belonging to the Ribera Del Duero sherry estate. Five years later,
                        he stumbled across an old vineyard “by luck” in the sub-region of La Horra. Not only did the
                        clay/limestone soil offer excellent drainage but there were remnants of vines planted in 1929.
                        Sisseck immediately bought the estate and the same year released 325 cases of ultra-powerful
                        Tempranillo. “I knew within 25 seconds of blind tasting that we&#39;d import the wine, despite
                        its weird name&quot;, says British wine emporium Corney and Barrow&#39;s managing director, Adam
                        Brett-Smith. Brett-Smith arranged a tasting with the hugely influential Robert Parker (this
                        being the 1990s was Parker’s time to shine) who gave it his highest possible score. It was sold
                        on entry into the market at €15; prices in 2019 are now well over €1,200 a bottle.
                    </div>

                    <div class="howto-title2">A behemoth of a bottle</div>
                    <div class="howto-text">
                        Like many great things, Pingus divides opinion. There are those that simply adore the dense
                        fruity taste, while others won’t touch it. Whether you like it or not, Pingus comes at a price.
                        In Q2 2019, an average bottle of Pingus was €800, with vintages such as the 2004 or 2014
                        stretching well into the thousands. But if you&#39;re really looking for a trophy then 1995 is
                        the fine wine investor’s holy grail. Almost 20% of the vintage is now at the bottom of the
                        Atlantic when the container ship that was exporting 75 cases to America sunk (500 cases of
                        Premier Cru Chateaux Lafitte were also lost). With a production of just 500 cases annually, we
                        will let you do the maths to work out how covetable that particular vintage has become. If
                        you’re looking for a more pocket-friendly wine that is as good to drink as to keep, we suggest
                        navigating towards Pingu’s second wine, Flor de Pingus.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Pingus",
    head: {
        title: 'Pingus | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wine-making craftsmanship of Pingus, a renowned Ribera del Duero wine producer known for producing highly sought-after and critically acclaimed red wines. Experience the rich, bold flavors of their premium wines made from the finest Tempranillo grapes grown in the heart of Spain\'s Ribera del Duero wine region.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Pingus', src: '/wine-guide/spain/ribera-del-duero/pingus'},
            items: [
                {report: 'Pingus', src: '/wine-guide/spain/ribera-del-duero/pingus'},
                {report: 'Vega Sicilia', src: '/wine-guide/spain/ribera-del-duero/vega-sicilia'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
